import CustomTextInput from "components/CustomTextInput";
import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { invitationCode } from "common/exportedFunctions";
import { sendEmailToAdmin } from "common/api";
import {
  addDoc,
  collection,
  db,
  getDocs,
  query,
  where,
} from "common/firebase-app";
import { Link } from "react-router-dom";
const RequestAccess = () => {
  const [status, setStatus] = useState({
    error: "",
    message: "",
  });
  const initialValues = {
    fullname: "",
    email: "",
    title: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid Email Address").required("Required"),
    fullname: Yup.string().required("Required"),
    title: Yup.string().required("Required"),
  });
  const onSubmit = async ({ email, fullname, title }) => {
    const code = invitationCode(); //6 digit number
    setStatus({
      message: "Submitting request...",
      error: "",
    });
    try {
      // check if email is already used
      const q = query(collection(db, "users"), where("email", "==", email));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.size > 0)
        throw new Error("This email is already used.");
      // Add a new invitation code request with auto-generated id.
      const docRef = await addDoc(collection(db, "users"), {
        fullname,
        email,
        code,
        title,
      });
      //Send an email to admin about a new invitation request
      await sendEmailToAdmin({
        fullname,
        email,
        title,
        code,
        id: docRef.id,
      });
      setStatus({
        message: "Request sent successfully!",
        error: "",
      });
    } catch (err) {
      setStatus({
        message: "",
        error: error.message,
      });
    }
  };
  const { error, message } = status;
  return (
    <div className="w-full h-screen md:w-1/2 mx-auto lg:w-3/12  flex flex-col items-center justify-center text-white px-2">
      <h1 className="w-full text-center font-bold text-customFontThirteen text-white">
        Request Access
      </h1>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <Form className="w-full">
          <CustomTextInput
            name="fullname"
            type="text"
            placeholder="Enter Full Name"
          />
          <CustomTextInput
            name="email"
            type="email"
            placeholder="Enter Email"
          />
          <CustomTextInput
            name="title"
            type="text"
            placeholder="Enter Job Title"
          />
          <button
            className="text-customFontFifteen text-white font-semibold rounded-full py-4 my-2 w-full bg-summer-sky cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            type="submit"
          >
            Submit
          </button>
        </Form>
      </Formik>
      {error && <p className="my-2 text-center text-red-500">{error}</p>}
      {message && <p className="my-2 text-center text-green-500">{message}</p>}
      <p className="my-2.5 w-full text-center">
       Do you have an Access Code?{" "}
        <Link
          to="/register"
          className="font-semibold text-cyan-500 cursor-pointer underline"
        >
          Sign up
        </Link>
      </p>
    </div>
  );
};

export default RequestAccess;
